import React, { useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from "../apiConfig";

const PasswordManage = () => {
  const history = useHistory();

  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;

  const [inpval, setINP] = useState({
    password: "",
    oldpassword: "",
    email: userInfo.email,
    user_id: userInfo.user_id,
  });

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(false);

  // ---- strength check ----
  const checkStrength = (pwd) => {
    let score = 0;
    const missing = [];

    if (pwd.length >= 8) score++;
    else missing.push("at least 8 characters");

    if (/[a-z]/.test(pwd)) score++;
    else missing.push("a lowercase letter");

    if (/[A-Z]/.test(pwd)) score++;
    else missing.push("an uppercase letter");

    if (/\d/.test(pwd)) score++;
    else missing.push("a number");

    if (/[^A-Za-z0-9]/.test(pwd)) score++;
    else missing.push("a special character (!@#$...)");

    let label = "Too Weak";
    let color = "#dc3545";
    if (score === 5) {
      label = "Strong";
      color = "#198754";
    } else if (score >= 3) {
      label = "Medium";
      color = "#fd7e14";
    } else if (score >= 1) {
      label = "Weak";
      color = "#dc3545";
    }

    return { score, label, color, missing };
  };

  const strength = checkStrength(inpval.password);
  const strengthPercent = (strength.score / 5) * 100;

  const setdata = (e) => {
    const { name, value } = e.target;
    setINP((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const addinpdata = async (e) => {
    e.preventDefault();

    const { password, oldpassword, email, user_id } = inpval;

    if (password.length < 6 || password.length > 30) {
      alert("Password should be between 6 and 30 characters");
      return;
    }

    if (oldpassword.length < 6) {
      alert("Old Password is required");
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    if (!passwordRegex.test(password)) {
      alert("Password must contain uppercase, lowercase, number and a special character");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${apiConfig.baseURL}/api/users/PasswordManage/${user_id}`,
        {
          password,
          oldpassword,
          email,
          user_id,
        }
      );

      if (res.status === 200) {
        alert("Updated Successfully ✅");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alert(error.response.data.msg);
      } else {
        alert("Server Error ❌");
      }
    }

    setLoading(false);
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body bg-light">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 bg-white rounded">
                  <h4 className="text-center mb-4 fw-bold">
                    🔐 Change Password
                  </h4>

                  <form onSubmit={addinpdata}>
                    {/* HIDDEN USERNAME - needed for Chrome autofill/suggest to trigger */}
                    <input
                      type="email"
                      name="username"
                      autoComplete="username"
                      value={inpval.email}
                      readOnly
                      style={{ display: "none" }}
                    />

                    {/* OLD PASSWORD */}
                    <div className="mb-3">
                      <label className="form-label">Old Password</label>
                      <div className="input-group">
                        <input
                          type={showOld ? "text" : "password"}
                          name="oldpassword"
                          autoComplete="current-password"
                          className="form-control"
                          placeholder="Enter old password"
                          value={inpval.oldpassword}
                          onChange={setdata}
                        />
                        <span
                          className="input-group-text"
                          onClick={() => setShowOld(!showOld)}
                          style={{ cursor: "pointer" }}
                        >
                          {showOld ? "🙈" : "👁"}
                        </span>
                      </div>
                    </div>

                    {/* NEW PASSWORD */}
                    <div className="mb-2">
                      <label className="form-label">New Password</label>
                      <div className="input-group">
                        <input
                          type={showNew ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          className="form-control"
                          placeholder="Enter new password"
                          value={inpval.password}
                          onChange={setdata}
                        />
                        <span
                          className="input-group-text"
                          onClick={() => setShowNew(!showNew)}
                          style={{ cursor: "pointer" }}
                        >
                          {showNew ? "🙈" : "👁"}
                        </span>
                      </div>
                    </div>

                    {/* STRENGTH METER */}
                    {inpval.password.length > 0 && (
                      <div className="mb-3">
                        <div
                          style={{
                            height: "6px",
                            width: "100%",
                            background: "#e9ecef",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              height: "100%",
                              width: `${strengthPercent}%`,
                              background: strength.color,
                              transition: "width 0.3s ease, background 0.3s ease",
                            }}
                          />
                        </div>
                        <small style={{ color: strength.color, fontWeight: 600 }}>
                          {strength.label}
                        </small>

                        {strength.missing.length > 0 && (
                          <ul
                            className="mb-0 mt-1"
                            style={{ fontSize: "12px", color: "#6c757d", paddingLeft: "18px" }}
                          >
                            {strength.missing.map((m, i) => (
                              <li key={i}>Add {m}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )}

                    {/* BUTTON */}
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-dark"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Update Password"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PasswordManage;